import React from "react";
import { FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import PropTypes from "prop-types";


export const DropDownWithOptions=({value, onChange, options, label, id}) => {

    return (

        <FormControl fullWidth>
        <InputLabel id={`${label}-select-label`}>{label}</InputLabel>
        <Select
            labelId={`${label}-select-label`}
            id={id || `${label}-select`}
            value={value || ''}
            label={label}
            onChange={onChange}
        >
            {Array.isArray(options) && options.map((optionValue) => (
            <MenuItem key={optionValue} value={optionValue}>
                {optionValue}
            </MenuItem>
            ))}
      </Select>
    </FormControl>
  );
}

DropDownWithOptions.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    label: PropTypes.string,
};